import { Component, OnInit } from "@angular/core";
import { AppService } from "app/services/app/app.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedModule } from '../../../shared.module';

@Component({
  selector: 'app-tenant-as',
  templateUrl: './tenant-as.component.html',
  styleUrls: ['./tenant-as.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class TenantAsComponent implements OnInit {

    constructor(public appService: AppService, private snack: MatSnackBar) {

    }

    ngOnInit() {
 
    }

    tenantAsOnChange($event) {
        this.snack.open(`Tenant establecido ${this.appService.tenantId}`, 'Cerrar', { duration: 3000 });
        setTimeout(()=> location.reload(), 1000);
    }

}
